export const TAG = {
  // Tag name for all posts
  ALL: "All",
}
